// Consent 결정/변경 로그 싱크. 현재는 dataLayer(GTM) + dev console.
// Sentry 도입 시 여기에 Sentry.addBreadcrumb 한 줄 추가하면 됨.
//
// 왜 필요한가: consent는 country/GPC/saved-cookie 조합이 많아 CS 티켓에서
// "왜 그렇게 결정됐는지" 역추적이 필수. 관측성 없으면 버그 재현 불가.

type ConsentEvent =
  | {
      name: "consent_init";
      source: "saved_cookie" | "fresh_visit";
      country?: string;
      isGdpr: boolean;
      gpc: boolean;
      // no_banner=true면 배너 미노출 지역(KR/JP 등)에서 묵시적 동의로 처리됐음을 기록.
      // audit 시 "유저가 어떻게 consent했나?"에 "배너 노출 없이 정책 기반 묵시 동의"로 답 가능.
      noBanner: boolean;
      shouldOptOut: boolean;
      hasConsented: boolean;
    }
  | {
      name: "consent_changed";
      action: "accept_all" | "accept_necessary" | "save_preferences";
      performance: boolean;
      advertising: boolean;
    }
  | {
      name: "consent_tracker_missing";
      tracker: "gtag" | "fbq" | "clarity";
    };

const warnedTrackers = new Set<string>();

export function logConsentEvent(event: ConsentEvent) {
  if (typeof window === "undefined") return;

  // 같은 tracker 누락은 세션당 한 번만 경고. 매 consent 업데이트마다 폭발 방지.
  if (event.name === "consent_tracker_missing") {
    if (warnedTrackers.has(event.tracker)) return;
    warnedTrackers.add(event.tracker);
  }

  window.dataLayer = window.dataLayer || [];
  window.dataLayer.push({ event: event.name, ...event });

  if (process.env.NEXT_PUBLIC_ENV !== "production") {
    console.info("[consent]", event);
  }
}

declare global {
  interface Window {
    dataLayer?: unknown[];
  }
}
